import { useContext } from "react";
import { RealtimeContext } from "./RealtimeContext";
import { AblyMessageCallback, ChannelParameters } from "ably/react";

export const useBindToChannelEvent = (channelOpts: ChannelParameters, event: string, handler: AblyMessageCallback) =>
    useContext(RealtimeContext).useChannel?.(channelOpts, event, message => handler(message.data));
